import React from "react";

import { Icon } from "../types";

const EconomicImpact: React.FC<Icon> = ({ color, width, height, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 13"
    fill={color}
    {...props}
  >
    <path
      d="M2.66667 3.25V13H18.5V3.25H2.66667ZM10.5833 11.375C8.83454 11.375 7.41667 9.919 7.41667 8.125C7.41667 6.331 8.83454 4.875 10.5833 4.875C12.3321 4.875 13.75 6.331 13.75 8.125C13.75 9.919 12.3321 11.375 10.5833 11.375ZM10.7417 9.73294V10.075H10.425V9.75081C10.098 9.74512 9.75763 9.6655 9.475 9.51437L9.61987 8.98056C9.92308 9.10081 10.326 9.22919 10.6403 9.15606C11.0045 9.07156 11.0797 8.68725 10.6775 8.502C10.3823 8.36225 9.48054 8.24037 9.48054 7.44819C9.48054 7.00456 9.80908 6.60806 10.425 6.52112V6.175H10.7417V6.50569C10.9705 6.51219 11.2278 6.55281 11.5159 6.64219L11.4003 7.17762C11.1573 7.09069 10.8889 7.01025 10.6269 7.02731C10.155 7.05575 10.1131 7.475 10.4432 7.6505C10.9847 7.91131 11.6917 8.10631 11.6917 8.80262C11.6917 9.36081 11.2665 9.65819 10.7417 9.73294ZM16.9167 2.4375H1.875V11.375H1.08333V1.625H16.9167V2.4375ZM15.3333 0.8125H0.291667V9.75H-0.5V0H15.3333V0.8125Z"
      fill={color}
    />
  </svg>
);
export default EconomicImpact;
